import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGravatars } from './selectors';
import { GravatarThunks } from './actions';
import { useFlags } from '@fullstory/react-hooks';

export const useGravatars = (users: { Email: string }[]) => {
  const dispatch = useDispatch();
  const gravatars = useSelector(getGravatars);
  const flags = useFlags();

  useEffect(() => {
    if (!flags.featureFlags().AppGravatarProfiles) return;
    dispatch(GravatarThunks.fetchGravatars(users.map(u => u.Email).filter(Boolean)));
  }, [users, dispatch, flags]);

  return gravatars;
};
